import ChangeStrokeColorAction from "./appearance/ChangeStrokeColorAction";
import ChangeFillColorAction from "./appearance/ChangeFillColorAction";
import ChangeStrokeWidthAction from "./appearance/ChangeStrokeWidthAction";
import CopyAppearanceAction from "./appearance/CopyAppearanceAction";
import MassAppearanceAction from "./appearance/MassAppearanceAction";
import AddSpeciesToElementAction from "./elements/AddSpeciesToElementAction";
import MoveAction from "./elements/MoveAction";
import RotateAction from "./elements/RotateAction";
import ChangeCustomLabelAction from "./labels/ChangeCustomLabelAction";
import DeleteCustomLabelAction from "./labels/DeleteCustomLabelAction";
import MoveLabelAction from "./labels/MoveLabelAction";
import NewCustomLabelAction from "./labels/NewCustomLabelAction";
import ToggleFillAction from "./appearance/ToggleFillAction";
import ToggleStrokeAction from "./appearance/ToggleStrokeAction";
import DrawAction from "./elements/DrawAction";
import DeleteAction from "./elements/DeleteAction";
import PlaceAction from "./elements/PlaceAction";
import RemoveSpeciesFromElementAction from "./elements/RemoveSpeciesFromElementAction";
import FieldInputAction from "./elements/FieldInputAction";
import MassReorderAction from "./elements/MassReorderAction";
import MassUpdateDateAction from "./elements/MassUpdateDateAction";
import MoveWithArrowKeyAction from "./elements/MoveWithArrowKeyAction";
import BringToFrontAction from "./elements/BringToFrontAction";
import SendToBackAction from "./elements/SendToBackAction";
import BringForwardAction from "./elements/BringForwardAction";
import SendBackwardAction from "./elements/SendBackwardAction";
import RotateImageAction from "./image/RotateImageAction";
import ScaleImageAction from "./image/ScaleImageAction";
import ChangeImageOpacityAction from "./image/ChangeImageOpacityAction";
import MoveLabelsAction from "./elements/MoveLabelsAction";
import AddPolyCoordinateAction from "./elements/AddPolyCoordinateAction";
import RemovePolyCoordinateAction from "./elements/RemovePolyCoordinateAction";
import ToggleCustomLabelVisibilityAction from "./labels/ToggleCustomLabelVisibilityAction";
import ChangeSpeciesLabelAction from "./labels/ChangeSpeciesLabelAction";
import ToggleLayerVisibilityAction from "./layers/ToggleLayerVisibilityAction";
import UpdateLayerAction from "./elements/UpdateLayerAction";
import UpdateDateAction from "./elements/UpdateDateAction";
import AddLayerAction from "./layers/AddLayerAction";
import RemoveLayerAction from "./layers/RemoveLayerAction";
import UpdateLayerNameAction from "./layers/UpdateLayerNameAction";
import UpdateLayerOpacityAction from "./layers/UpdateLayerOpacityAction";
import ChangeSegmentTypeAction from "./elements/ChangeSegmentTypeAction";
import ChangeCanopyStyleAction from "./elements/ChangeCanopyStyleAction";

// Labels
const NEW_CUSTOM_LABEL = 'NEW_CUSTOM_LABEL';
const CHANGE_CUSTOM_LABEL = 'CHANGE_CUSTOM_LABEL';
const DELETE_CUSTOM_LABEL = 'DELETE_CUSTOM_LABEL';
const MOVE_LABEL = 'MOVE_LABEL';
const TOGGLE_CUSTOM_LABEL_VISIBILITY = 'TOGGLE_CUSTOM_LABEL_VISIBILITY';
const CHANGE_SPECIES_LABEL = 'CHANGE_SPECIES_LABEL';

// Elements
const DRAW = 'DRAW';
const DELETE = 'DELETE';
const PLACE = 'PLACE';
const MOVE = 'MOVE';
const ROTATE = 'ROTATE';
const LABELS = 'LABELS';
const RESHAPE = 'RESHAPE';
const ADD_SPECIES_TO_ELEMENT = 'ADD_SPECIES_TO_ELEMENT';
const REMOVE_SPECIES_FROM_ELEMENT = 'REMOVE_SPECIES_FROM_ELEMENT';
const FIELD_INPUT = 'FIELD_INPUT';
const MOVE_WITH_ARROW_KEY = 'MOVE_WITH_ARROW_KEY';
const BRING_TO_FRONT = 'BRING_TO_FRONT';
const SEND_TO_BACK = 'SEND_TO_BACK';
const BRING_FORWARD = 'BRING_FORWARD';
const SEND_BACKWARD = 'SEND_BACKWARD';
const ADD_POLY_COORDINATE = 'ADD_POLY_COORDINATE';
const REMOVE_POLY_COORDINATE = 'REMOVE_POLY_COORDINATE';
const CHANGE_SEGMENT_TYPE = 'CHANGE_SEGMENT_TYPE';
const CHANGE_CANOPY_STYLE = 'CHANGE_CANOPY_STYLE';
const MASS_REORDER = 'MASS_REORDER';
const MASS_UPDATE_DATE = 'MASS_UPDATE_DATE';
const UPDATE_LAYER = 'UPDATE_LAYER';
const UPDATE_DATE = 'UPDATE_DATE';

// Appearance
const CHANGE_FILL_COLOR = 'CHANGE_FILL_COLOR';
const CHANGE_STROKE_COLOR = 'CHANGE_STROKE_COLOR';
const CHANGE_STROKE_WIDTH = 'CHANGE_STROKE_WIDTH';
const TOGGLE_FILL = 'TOGGLE_FILL';
const TOGGLE_STROKE = 'TOGGLE_STROKE';
const COPY_APPEARANCE = 'COPY_APPEARANCE';
const MASS_APPEARANCE = 'MASS_APPEARANCE';

// Image
const ADD_IMAGE = 'ADD_IMAGE';
const REMOVE_IMAGE = 'REMOVE_IMAGE';
const CHANGE_IMAGE = 'CHANGE_IMAGE';
const MOVE_IMAGE = 'MOVE_IMAGE';
const SCALE_IMAGE = 'SCALE_IMAGE';
const ROTATE_IMAGE = 'ROTATE_IMAGE';
const CHANGE_IMAGE_OPACITY = 'CHANGE_IMAGE_OPACITY';

// Layers
const TOGGLE_LAYER_VISIBILITY = 'TOGGLE_LAYER_VISIBILITY';
const ADD_LAYER = 'ADD_LAYER';
const REMOVE_LAYER = 'REMOVE_LAYER';
const UPDATE_LAYER_NAME = 'UPDATE_LAYER_NAME';
const UPDATE_LAYER_OPACITY = 'UPDATE_LAYER_OPACITY';

const ACTION_MAP = {
    // Labels
    NEW_CUSTOM_LABEL: NewCustomLabelAction,
    CHANGE_CUSTOM_LABEL: ChangeCustomLabelAction,
    DELETE_CUSTOM_LABEL: DeleteCustomLabelAction,
    MOVE_LABEL: MoveLabelAction,
    TOGGLE_CUSTOM_LABEL_VISIBILITY: ToggleCustomLabelVisibilityAction,
    CHANGE_SPECIES_LABEL: ChangeSpeciesLabelAction,

    // Elements
    DRAW: DrawAction,
    MOVE: MoveAction,
    ROTATE: RotateAction,
    LABELS: MoveLabelsAction,
    DELETE: DeleteAction,
    PLACE: PlaceAction,
    ADD_SPECIES_TO_ELEMENT: AddSpeciesToElementAction,
    REMOVE_SPECIES_FROM_ELEMENT: RemoveSpeciesFromElementAction,
    FIELD_INPUT: FieldInputAction,
    MOVE_WITH_ARROW_KEY: MoveWithArrowKeyAction,
    BRING_TO_FRONT: BringToFrontAction,
    SEND_TO_BACK: SendToBackAction,
    BRING_FORWARD: BringForwardAction,
    SEND_BACKWARD: SendBackwardAction,
    ADD_POLY_COORDINATE: AddPolyCoordinateAction,
    REMOVE_POLY_COORDINATE: RemovePolyCoordinateAction,
    CHANGE_SEGMENT_TYPE: ChangeSegmentTypeAction,
    CHANGE_CANOPY_STYLE: ChangeCanopyStyleAction,
    MASS_REORDER: MassReorderAction,
    MASS_UPDATE_DATE: MassUpdateDateAction,
    UPDATE_LAYER: UpdateLayerAction,
    UPDATE_DATE: UpdateDateAction,

    // Appearance
    CHANGE_FILL_COLOR: ChangeFillColorAction,
    CHANGE_STROKE_COLOR: ChangeStrokeColorAction,
    CHANGE_STROKE_WIDTH: ChangeStrokeWidthAction,
    TOGGLE_FILL: ToggleFillAction,
    TOGGLE_STROKE: ToggleStrokeAction,
    COPY_APPEARANCE: CopyAppearanceAction,
    MASS_APPEARANCE: MassAppearanceAction,

    // Image
    SCALE_IMAGE: ScaleImageAction,
    ROTATE_IMAGE: RotateImageAction,
    CHANGE_IMAGE_OPACITY: ChangeImageOpacityAction,

    // Layers
    TOGGLE_LAYER_VISIBILITY: ToggleLayerVisibilityAction,
    ADD_LAYER: AddLayerAction,
    REMOVE_LAYER: RemoveLayerAction,
    UPDATE_LAYER_NAME: UpdateLayerNameAction,
    UPDATE_LAYER_OPACITY: UpdateLayerOpacityAction,

    /**
     * Custom handling by factory:
     * RESHAPE
     * MOVE_IMAGE
     */
};

export {
    // Labels
    NEW_CUSTOM_LABEL,
    CHANGE_CUSTOM_LABEL,
    DELETE_CUSTOM_LABEL,
    MOVE_LABEL,
    TOGGLE_CUSTOM_LABEL_VISIBILITY,
    CHANGE_SPECIES_LABEL,

    // Elements
    DRAW,
    MOVE,
    ROTATE,
    LABELS,
    DELETE,
    PLACE,
    RESHAPE,
    ADD_SPECIES_TO_ELEMENT,
    REMOVE_SPECIES_FROM_ELEMENT,
    FIELD_INPUT,
    MOVE_WITH_ARROW_KEY,
    BRING_TO_FRONT,
    SEND_TO_BACK,
    BRING_FORWARD,
    SEND_BACKWARD,
    ADD_POLY_COORDINATE,
    REMOVE_POLY_COORDINATE,
    CHANGE_SEGMENT_TYPE,
    CHANGE_CANOPY_STYLE,
    MASS_REORDER,
    MASS_UPDATE_DATE,
    UPDATE_LAYER,
    UPDATE_DATE,

    // Appearance
    CHANGE_FILL_COLOR,
    CHANGE_STROKE_COLOR,
    CHANGE_STROKE_WIDTH,
    TOGGLE_FILL,
    TOGGLE_STROKE,
    COPY_APPEARANCE,
    MASS_APPEARANCE,

    // Image
    MOVE_IMAGE,
    SCALE_IMAGE,
    ROTATE_IMAGE,
    CHANGE_IMAGE_OPACITY,

    // Layers
    TOGGLE_LAYER_VISIBILITY,
    ADD_LAYER,
    REMOVE_LAYER,
    UPDATE_LAYER_NAME,
    UPDATE_LAYER_OPACITY,

    ACTION_MAP,
};
